<script lang="ts" setup>
const emit = defineEmits<{
  (e: 'close'): void
}>()

const toolbarBottom = ref(0)
const container = useTemplateRef<HTMLElement>('container')

onMounted(() => {
  if (window.visualViewport) {
    const updatePosition = () => {
      if (!window.visualViewport) return
      const viewport = window.visualViewport
      const offsetBottom =
        window.innerHeight - viewport.height - viewport.offsetTop
      toolbarBottom.value = offsetBottom
    }

    window.visualViewport.addEventListener('resize', updatePosition)
    window.visualViewport.addEventListener('scroll', updatePosition)

    updatePosition()

    onBeforeUnmount(() => {
      window.visualViewport?.removeEventListener('resize', updatePosition)
      window.visualViewport?.removeEventListener('scroll', updatePosition)
    })
  }
})
</script>

<template>
  <Teleport to="body">
    <div
      class="fixed inset-0 bg-neutral-200/20 dark:bg-neutral-900/20"
      @click.stop="emit('close')"
    />
    <Transition name="slide" appear>
      <section
        ref="container"
        role="dialog"
        aria-modal="true"
        class="shadow-lg rounded-3xl fixed! left-2 right-2 p-4 bg-neutral-200/80 dark:bg-neutral-800/80 backdrop-blur-xl"
        :style="{ bottom: `calc(${toolbarBottom}px + 0.5rem) !important` }"
      >
        <slot @click.stop />
      </section>
    </Transition>
  </Teleport>
</template>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: all 240ms ease;
}

.slide-enter-from,
.slide-leave-to {
  translate: 0 100%;
}

.slide-enter-to,
.slide-leave-from {
  translate: 0 0;
}
</style>
